/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { TextField } from 'components/elements/FormControls/TextField';

function CustomTextField(props) {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <TextField
      data-testid="password"
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton data-testid="icon-button" onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} edge="end" size="large">
              {showPassword ? <VisibilityOff data-testid="visible" /> : <Visibility data-testid="hidden" />}
              <span className="sr-only">Show password</span>
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...props}
    />
  );
}

CustomTextField.propTypes = TextField.propTypes;

export default CustomTextField;
